export const actions = {
  CATEGORIAS_LOAD_REQUESTED: 'CATEGORIAS_LOAD_REQUESTED',
  CATEGORIAS_LOAD_FILTERED_REQUESTED: 'CATEGORIAS_LOAD_FILTERED_REQUESTED',
  CATEGORIAS_CHILD_LOAD_REQUESTED: 'CATEGORIAS_CHILD_LOAD_REQUESTED',
  CATEGORIAS_LOAD_SUCCEEDED: 'CATEGORIAS_LOAD_SUCCEEDED',
  CATEGORIAS_LOAD_FILED: 'CATEGORIAS_LOAD_FILED',

  SUBCATEGORIAS_LOAD_REQUESTED: 'SUBCATEGORIAS_LOAD_REQUESTED',
  SUBCATEGORIAS_LOAD_SUCCEEDED: 'SUBCATEGORIAS_LOAD_SUCCEEDED',
  SUBCATEGORIAS_LOAD_FILED: 'SUBCATEGORIAS_LOAD_FILED',

  CATEGORIA_PERSONALIZADOS_LOAD_REQUESTED: 'CATEGORIA_PERSONALIZADOS_LOAD_REQUESTED',
  CATEGORIA_PERSONALIZADOS_LOAD_SUCCEEDED: 'CATEGORIA_PERSONALIZADOS_LOAD_SUCCEEDED',
  CATEGORIA_PERSONALIZADOS_LOAD_FILED: 'CATEGORIA_PERSONALIZADOS_LOAD_FILED',

  CATEGORIA_PERSONALIZADOS_UPDATE_REQUESTED: 'CATEGORIA_PERSONALIZADOS_UPDATE_REQUESTED',
  CATEGORIA_PERSONALIZADOS_UPDATE_SUCCEEDED: 'CATEGORIA_PERSONALIZADOS_UPDATE_SUCCEEDED',
  CATEGORIA_PERSONALIZADOS_UPDATE_FILED: 'CATEGORIA_PERSONALIZADOS_UPDATE_FILED',

  CATEGORIA_BYID_LOAD_REQUESTED: 'CATEGORIA_BYID_LOAD_REQUESTED',
  CATEGORIA_BYID_LOAD_SUCCEEDED: 'CATEGORIA_BYID_LOAD_SUCCEEDED',
  CATEGORIA_BYID_LOAD_FILED: 'CATEGORIA_BYID_LOAD_FILED',

  CATEGORIA_BYID_LOAD_INSERT_REQUESTED: 'CATEGORIA_BYID_LOAD_INSERT_REQUESTED',

  CATEGORIA_UPDATE_REQUESTED: 'CATEGORIA_UPDATE_REQUESTED',
  CATEGORIA_UPDATE_SUCCEEDED: 'CATEGORIA_UPDATE_SUCCEEDED',
  CATEGORIA_UPDATE_FILED: 'CATEGORIA_UPDATE_FILED',

  CATEGORIA_INSERT_REQUESTED: 'CATEGORIA_INSERT_REQUESTED',
  CATEGORIA_INSERT_SUCCEEDED: 'CATEGORIA_INSERT_SUCCEEDED',
  CATEGORIA_INSERT_FILED: 'CATEGORIA_INSERT_FILED',

  CATEGORIA_DELETE_REQUESTED: 'CATEGORIA_DELETE_REQUESTED',
  CATEGORIA_DELETE_SUCCEEDED: 'CATEGORIA_DELETE_SUCCEEDED',
  CATEGORIA_DELETE_FILED: 'CATEGORIA_DELETE_FILED',

  CATEGORIAS_DELETE_REQUESTED: 'CATEGORIAS_DELETE_REQUESTED',
  CATEGORIAS_DELETE_SUCCEEDED: 'CATEGORIAS_DELETE_SUCCEEDED',
  CATEGORIAS_DELETE_FILED: 'CATEGORIAS_DELETE_FILED',
}

export const getCategoriasAction = dispatch => {
  dispatch({
    type: actions.CATEGORIAS_LOAD_REQUESTED,
  })
}

export const getCategoriasChildAction = dispatch => {
  dispatch({
    type: actions.CATEGORIAS_CHILD_LOAD_REQUESTED,
  })
}

export const getCategoriasFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.CATEGORIAS_LOAD_FILTERED_REQUESTED,
    payload: filter,
  })
}

export const getCategoriasSelectAction = dispatch => {
  dispatch({
    type: actions.CATEGORIAS_LOAD_FILTERED_REQUESTED,
    payload: { padreId: 10 },
  })
}

export const getSubCategoriasAction = (dispatch, padreId) => {
  dispatch({
    type: actions.SUBCATEGORIAS_LOAD_REQUESTED,
    payload: padreId,
  })
}

export const getCategoriaPersonalizadosAction = dispatch => {
  dispatch({
    type: actions.CATEGORIA_PERSONALIZADOS_LOAD_REQUESTED,
  })
}

export const getCategoriaCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.CATEGORIA_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.CATEGORIA_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertCategoriaFormAction = (dispatch, formCategoria) => {
  dispatch({
    type: actions.CATEGORIA_INSERT_REQUESTED,
    payload: formCategoria,
  })
}

export const onSubmitUpdateCategoriaFormAction = (dispatch, formCategoria) => {
  dispatch({
    type: actions.CATEGORIA_UPDATE_REQUESTED,
    payload: formCategoria,
  })
}

export const onSubmitUpdateCategoriaPersonalizadoFormAction = (dispatch, formCategoriaPerso) => {
  dispatch({
    type: actions.CATEGORIA_PERSONALIZADOS_UPDATE_REQUESTED,
    payload: formCategoriaPerso,
  })
}

export const deleteCategoriaAction = (dispatch, id) => {
  dispatch({
    type: actions.CATEGORIA_DELETE_REQUESTED,
    payload: id,
  })
}

export const deleteListCategoriaAction = (dispatch, ids) => {
  dispatch({
    type: actions.CATEGORIAS_DELETE_REQUESTED,
    payload: ids,
  })
}
